module.exports = __webpack_public_path__ + "static/media/success-circle-fill.b0422871.svg";